var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg164UpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M474.135,192.825L298.429,17.549c-23.396-23.395-61.463-23.395-84.839-0.018L37.864,192.823 c-7.82,7.802-7.836,20.466-0.035,28.286c7.802,7.821,20.466,7.835,28.285,0.035L241.858,45.833 c7.797-7.797,20.487-7.798,28.302,0.018l175.725,175.294c3.904,3.894,9.015,5.84,14.126,5.84c5.126,0,10.253-1.959,14.16-5.874 C481.972,213.29,481.956,200.626,474.135,192.825z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256,108.979c-11.047,0-20.001,8.954-20.001,20.001v363.018c0,11.047,8.954,20.001,20.001,20.001 s20.001-8.954,20.001-20.001V128.98C276.001,117.934,267.047,108.979,256,108.979z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg164UpArrow);
export default __webpack_public_path__ + "static/media/164-up-arrow.6d29c0907f4e2908fda25f7708dd8d75.svg";
export { ForwardRef as ReactComponent };